export default {"src":"/_next/static/media/shoppingCart_40.ab072533.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};